import { Component } from '@verndale/core';
import { timeline } from 'motion';
import { throttle, debounce } from '../../helpers';

class ScrollAnimation extends Component {
  setupDefaults() {
    this.isMobile = window.matchMedia('(max-width: 768px)').matches;

    this.dom = {
      logo: this.isMobile
        ? this.el.querySelector('.header__logo img')
        : this.el.querySelector('.header__logo-mobile img')
    };
    this.root = document.querySelector(':root');
    this.scrollDelta = 50;
    this.lastScrollTop = 0;
    this.scrolledUp = true;
    this.setSequences();
    this.setHeight(100);
  }

  addListeners() {
    window.addEventListener(
      'scroll',
      throttle(this.handleScroll.bind(this), 100)
    );
    window.addEventListener(
      'resize',
      debounce(this.handleResize.bind(this), 100)
    );
  }

  setHeight(value) {
    this.root.style.setProperty('--header-height', `${value}px`);
    this.root.style.setProperty('--header-mobile-height', '60px');
  }

  setSequences() {
    this.dom.logo = this.isMobile
      ? this.el.querySelector('.header__logo-mobile img')
      : this.el.querySelector('.header__logo img');

    this.showScrolledLogoSequence = [
      [
        this.dom.logo,
        { scale: this.isMobile ? [1, 1.46] : [1, 1.25] },
        { at: 0 },
        { duration: 0.25 }
      ],
      // [this.el, { height: this.isMobile ? [] : ['100px', '65px'] }, { at: 0 }]
    ];

    this.showNormalLogoSequence = [
      [
        this.dom.logo,
        { scale: this.isMobile ? [1.45, 1] : [1.25, 1] },
        { at: 0 },
        { duration: 0.25 }
      ],
      // [this.el, { height: this.isMobile ? [] : ['75px', '100px'] }, { at: 0 }]
    ];
  }

  handleResize() {
    if (this.isMobile && !window.matchMedia('(max-width: 768px)').matches) {
      this.isMobile = false;
    } else if (
      !this.isMobile &&
      window.matchMedia('(max-width: 768px)').matches
    ) {
      this.isMobile = true;
    }
    this.setSequences();
  }

  handleScroll() {
    const currentScroll = window.scrollY;
    if (Math.abs(this.lastScrollTop - currentScroll) <= this.scrollDelta)
      return;

    if (this.lastScrollTop - currentScroll > 0 && !this.scrolledUp) {
      this.setHeight(100);

      timeline(this.showNormalLogoSequence).finished.then(() =>
        this.setHeight(100)
      );
      this.scrolledUp = true;
    } else if (this.lastScrollTop - currentScroll < 0 && this.scrolledUp) {
      this.setHeight(75);

      timeline(this.showScrolledLogoSequence).finished.then(() =>
        this.setHeight(75)
      );
      this.scrolledUp = false;
    }
    this.lastScrollTop = currentScroll;
  }
}

export default ScrollAnimation;
